import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Autocomplete from '@material-ui/lab/Autocomplete';


const useStyles = makeStyles(theme => ({
  title : {
    color: theme.palette.common.nightBlue,
    marginBottom: '10px',
  },
}));

const searchTextBoxStyles = makeStyles(theme => ({
  input: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: '2px solid',
        borderRadius: '10px',
        borderColor: theme.palette.common.tealish,
      },
      '& input': {
        margin: '8px 0 8px 4px',
        fontSize: '16px'
      },
      '& .MuiChip-label': {
        fontSize: '16px',
        lineHeight: '16px'
      },
      '& .MuiAutocomplete-tag': {
        height: '38px',
        borderRadius: '30px'
      },
    }
  },
  spinner: {
    padding: 5,
  },
}));

const SearchBox = (
  {
    title,
    options,
    placeholder,
    selectedValue,
    onSearchChange,
    inputRenderer=renderInput
  }) => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h3" className={classes.title}>{title}</Typography>
      <Autocomplete
        options={options}
        getOptionLabel={option => option.name}
        getOptionSelected={(option, value) => option.name === value.name }
        autoComplete
        autoHighlight
        filterSelectedOptions
        value={selectedValue}
        onChange={(event, value) => {
          onSearchChange(value);
        }}
        renderInput={params => inputRenderer(placeholder, false, params)}
      />
    </>
  );
};

const renderInput = (placeholder, loading=false, params) => {
  const classes = searchTextBoxStyles();

  return (
    <Box display="flex" alignItems="center" >
      <Box flexGrow={1}>
        <TextField
          className={classes.input}
          {...params}
          placeholder={placeholder}
          variant="outlined"
        />
      </Box>
      {loading && (
        <Box className={classes.spinner}>
          <CircularProgress size={20} thickness={5}/>
        </Box>
      )}
    </Box>
  );
};

SearchBox.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  selectedValue: PropTypes.object,
  onSearchChange: PropTypes.func.isRequired,
  inputRenderer: PropTypes.func,
};


export default SearchBox;